// file utilities
import config from '../config'
import {formatDate, approxSize} from './common'
import {i18n} from '@/utils/i18n'

export const normalizeFile = (file) => {
  setThumbIcon(file)
  file.action_permissions = getActionPermissions(file)

  if (file.hasOwnProperty('size')) {
    file.approx_size = approxSize(file.size)
  }

  file.action_status = file.action_status || {}
  if (file.action_status.action_time || file.modified_at) {
    file.action_time = formatDate((file.action_status.action_time || file.modified_at) * (file.id ? 1000 : 1))
  }

  if (file.changed_time) {
    file.format_changed_time = formatDate(file.changed_time * 1000)
  }

  // TODO: Maybe not always false
  if (file.selected === undefined) file.selected = false

  if (file.is_deleted === undefined) {
    file.is_deleted = false
  }

  // var action_status = file.action_status;
  // if(action_status && action_status.action_type === 'deleted'){
  //     var time_left = $('#trash_period').val() * 86400 + action_status.action_time;
  //     file.trash_time_left = formatDate(time_left * 1000, '%L');
  // }
  if (file.isTopCollabFolder) {
    let fullPaths = fullPathList4CollableFolder(file)
    if (fullPaths && fullPaths.length > 0) {
      file.root_path_for_collab = fullPaths[0]
    }
  }
  return file
}

export const normalizeUploadedFileWithAccessToken = (file) => {
  setThumbIcon(file)

  if (file.hasOwnProperty('size')) {
    file.approx_size = approxSize(file.size)
  }

  // 开放平台WithAccessToken上传文件后返回的space信息与主站不同，这里为了统一处理，调整下
  if (typeof file.space === 'object') {
    file.spaceInfo = file.space
    file.space = file.space.type
  }

  file.action_status = file.action_status || {}
  if (file.action_status.action_time || file.modified_at) {
    file.action_time = formatDate((file.action_status.action_time || file.modified_at) * (file.id ? 1000 : 1))
  }

  if (file.changed_time) {
    file.format_changed_time = formatDate(file.changed_time * 1000)
  }

  // TODO: Maybe not always false
  if (file.selected === undefined) file.selected = false

  if (file.is_deleted === undefined) {
    file.is_deleted = false
  }

  // var action_status = file.action_status;
  // if(action_status && action_status.action_type === 'deleted'){
  //     var time_left = $('#trash_period').val() * 86400 + action_status.action_time;
  //     file.trash_time_left = formatDate(time_left * 1000, '%L');
  // }
  return file
}

export const fileTypeIconMaps = {
  'doc': 'doc',
  'docx': 'doc',
  'rtf': 'doc',
  'wps': 'doc',
  'wpt': 'doc',
  'odt': 'doc',
  'docm': 'doc',
  'dot': 'doc',
  'dotm': 'doc',
  'dotx': 'doc',
  'ppt': 'ppt',
  'pptx': 'ppt',
  'odp': 'ppt',
  'dpt': 'ppt',
  'dps': 'ppt',
  'ppsx': 'ppt',
  'pot': 'ppt',
  'potm': 'ppt',
  'potx': 'ppt',
  'pps': 'ppt',
  'ppsm': 'ppt',
  'pptm': 'ppt',
  'xls': 'xls',
  'xlsx': 'xls',
  'xltx': 'xls',
  'xlt': 'xls',
  'ods': 'xls',
  'et': 'xls',
  'ett': 'xls',
  'xlsb': 'xls',
  'xlsm': 'xls',
  'xltm': 'xls',
  'pdf': 'pdf',
  'psd': 'psd',
  'html': 'html',
  'xhtml': 'html',
  'htm': 'html',
  'ai': 'ai',
  'csv': 'csv',
  'ydoc': 'ydoc',
  'yxls': 'yxls',
  'vsd': 'visio',
  'vsdx': 'visio',
  'vsdm': 'visio',
  'vdw': 'visio',
  'mpp': 'project',
  'markdown': 'text',
  'md': 'text',
  'mdown': 'text',
  'tsv': 'text',
  'zip': 'zip',
  'rar': 'zip'
}

// set thumbnail or icon for file
export const setThumbIcon = file => {
  if (file.hasOwnProperty('icon')) {
    file.type_icon = file.icon
    delete file.icon
    return
  }
  delete file.type_icon
  delete file.thumbnail
  if (!file.is_deleted && !file.hasOwnProperty('show_icon') && (file.small_thumbnail_generated || file.median_thumbnail_generated) && file.permissions && file.permissions.includes('item_preview')) {
    // TODO: real url get
    let param = ''
    if (file.file_version_id) {
      param = 'file_version_id=' + file.file_version_id
    } else {
      param = 'file_id=' + (file.id || file.file_id)
    }

    if (file.from_share) {
      param += '&scenario=share'
    }

    if (file.file_version_key) {
      param += '&file_version_key=' + file.file_version_key
    }

    if (file.small_thumbnail_generated) {
      file.thumbnail = config.imageUrl + '/apps/representations/download?' + param + '&kind=image_64'
    }

    if (file.median_thumbnail_generated) {
      file.median_thumbnail = config.imageUrl + '/apps/representations/download?' + param + '&kind=image_128'
    }

    if (!file.hasOwnProperty('thumbnail') && file.hasOwnProperty('median_thumbnail')) {
      file.thumbnail = file.median_thumbnail
    }

    let icon = 'default'
    if (file.type === 'folder') {
      icon = file.is_external_collab_folder ? 'external-collab-folder' : (file.is_owned_collab_folder || file.is_invited_collab_folder ? 'collab-folder' : 'folder')
    } else {
      if (fileTypeIconMaps[file.extension ? file.extension.toLowerCase() : '']) {
        icon = fileTypeIconMaps[file.extension.toLowerCase()]
      } else if (['text', 'image', 'rvt', 'audio', 'video', 'cad', 'zip'].indexOf(file.extension_category) > -1) {
        icon = file.extension_category
      }
    }
    file.type_icon = icon
  } else {
    var icon = 'default'
    if (file.type === 'folder') {
      icon = file.is_external_collab_folder ? 'external-collab-folder' : (file.is_owned_collab_folder || file.is_invited_collab_folder ? 'collab-folder' : 'folder')
    } else {
      if (fileTypeIconMaps[file.extension ? file.extension.toLowerCase() : '']) {
        icon = fileTypeIconMaps[file.extension.toLowerCase()]
      } else if (['text', 'image', 'rvt', 'audio', 'video', 'cad', 'zip'].indexOf(file.extension_category) > -1) {
        icon = file.extension_category
      }
    }
    file.type_icon = icon
  }
}

export const setFolderThumbIcon = (folder) => {
  folder.type_icon = folder.is_external_collab_folder ? 'external-collab-folder' : (folder.is_owned_collab_folder || folder.is_invited_collab_folder ? 'collab-folder' : 'folder')
}

export const getTypeIcon = (file) => {
  let icon = 'default'
  if (file.type === 'folder') {
    icon = 'folder'
  } else if (fileTypeIconMaps[file.ext]) {
    icon = fileTypeIconMaps[file.ext]
  } else if (file.mimeType) {
    let m = /(text|image|audio|video)\//.exec(file.type)
    if (m) {
      icon = m[1]
    }
  } else if (/jpg|jpeg|png|gif/i.test(file.ext)) {
    icon = 'image'
  }
  return icon
}

export const isShareDisabled = (item, memberOnly) => {
  const { is_share_disabled, is_share_link_public_access_disabled, owned_by } = item
  if (!owned_by) { return is_share_disabled }
  const enterprise_id = owned_by.enterprise_id

  // BIGBANG-2371
  const companyMemberOnly = is_share_link_public_access_disabled && (config.enterprise_info.id !== enterprise_id)
  return memberOnly ? companyMemberOnly : (is_share_disabled || companyMemberOnly)
}

export const getActionPermissions = (item) => {
  /* eslint-disable eqeqeq */
  const loginUser = config.user_info || {}
  // 如果是华图dlp用户，加密文件夹取消移动权限
  let disableMove = item.is_encrypted && config.viewConfig.isDlpEnabled

  let permissions = item.permissions ? item.permissions : []
  let action_permissions = []
  const unlock_permit = item.unlock_permit && item.locked
  const unlocked = (unlock_permit && item.lock_user && item.lock_user.id == loginUser.id) || !item.locked
  const perm_delete = (item.department && item.parent_folder_id == 0 ? (item.department.permissions && item.department.permissions.includes('delete_folder')) : permissions.includes('item_delete')) /* && unlocked */ && !item.is_deleted
  const is_owner = item.owned_by && item.owned_by.id == loginUser.id
  const is_yiqixie = item.extension === 'ydoc' || item.extension === 'yxls'

  // would have 'perm_share' but with a disabled menu
  // 'perm_manage_my_share' will be removed because of not showing
  // const shareDisabled = isShareDisabled(item)

  const permission_list = {
    // 'perm_change_owner': !!loginUser.enterprise_id && item.parent_folder_id === 0 && !item.department && item.type === 'folder' && item.owned_by.id == loginUser.id,
    'perm_frequent': permissions.includes('item_view') && !item.is_frequently_used, // 上传者以上
    'perm_unfrequent': item.is_frequently_used,
    'perm_share': permissions.includes('item_share') && !config.university_account_status,
    'perm_share_to_colleague': permissions.includes('item_share') && !config.enterprise_info.is_personal_user_enterprise,
    // 'perm_manage_my_share': permissions.includes('item_share') && !shareDisabled,
    // 'perm_view_my_share': permissions.includes('item_share') && !item.is_share_disabled && !PROCESS_WHITELIST_CONFIG.share_enabled,
    // 'perm_view_others_shares': !PROCESS_WHITELIST_CONFIG.share_enabled && !item.is_share_disabled && permissions.includes('item_share') && config.share_link_view_others && (item.final_role === 'coowner' || permissions.includes('item_own')),
    // 'perm_lock': !item.locked && (item.lock_enable || item.is_collab_folder) && permissions.includes('item_download') && permissions.includes('item_upload') && item.type === 'file',
    // 'perm_unlock': unlock_permit,
    'perm_preview': permissions.includes('item_preview') && item.type === 'file' && item.scope != 1,
    'perm_view': permissions.includes('item_view') && !item.is_deleted,
    'perm_open_folder': permissions.includes('item_view') && item.type === 'folder',
    'perm_download': permissions.includes('item_download') && !is_yiqixie && !item.is_encrypted && !config.viewConfig.isH5HideShareLinkDownload,
    'perm_delete': perm_delete,
    'perm_move': perm_delete && permissions.includes('item_download') && !disableMove,
    'perm_copy': permissions.includes('item_download'),
    'perm_comment': permissions.includes('item_create_comment'),
    // 'perm_view_activites': permissions.includes('item_preview'), // TODO
    'perm_view_collab': permissions.includes('item_view') && item.type === 'folder',
    'perm_create_collab': permissions.includes('item_create_collab') && item.type === 'folder',
    'perm_view_version': permissions.includes('item_view') && item.type === 'file' && !is_yiqixie,
    'perm_update_version': permissions.includes('item_upload') && item.type === 'file'/* && unlocked */,
    // 'perm_sync': permissions.includes('item_download') && item.type === 'folder' && (item.sync_status === 'item_without_sync' || (!window.sync_v2 && !config.is_resource_custom_enterprise)) && !config.isSyncDisabled && !(window.sync_v2 && !config.encrypt_sync_enabled && item.is_encrypted),
    // 'perm_sync_all': permissions.includes('item_download') && item.type === 'folder' && item.sync_status === 'item_contains_sync' && window.sync_v2 && !config.isSyncDisabled,
    // 'perm_unsync': permissions.includes('item_download') && item.type === 'folder' && (item.sync_status === 'item_is_sync' || item.sync_status === 'item_contains_sync') && window.sync_v2 && !config.isSyncDisabled,
    // 'perm_open_local': permissions.includes('item_download') && item.type === 'folder' && (item.sync_status === 'item_is_sync' || item.sync_status === 'item_in_sync' || item.sync_status === 'item_contains_sync') && window.sync_v2 && !config.isSyncDisabled,
    // 'perm_open_local_folder': permissions.includes('item_download') && item.type === 'file' && (item.sync_status === 'item_is_sync' || item.sync_status === 'item_in_sync') && window.sync_v2 && !config.isSyncDisabled && !is_yiqixie,
    // 'perm_review': permissions.includes('item_download') && item.type === 'file' && PROCESS_WHITELIST_CONFIG.review_enable && !isItemNeedsApproval(item),
    // 'perm_manage_review': permissions.includes('item_download') && item.type === 'file' && PROCESS_WHITELIST_CONFIG.review_enable,
    'perm_edit': permissions.includes('item_upload') && permissions.includes('item_download') && item.type === 'file',
    'perm_edit_online': permissions.includes('item_upload') && (item.final_role === 'online_collaborator' ? permissions.includes('item_preview') : permissions.includes('item_download')) && item.type === 'file' && (item.is_support_oos_edit || item.is_online_collab_edit_enable) && !config.viewConfig.is_changxie_edit_enabled,
    'perm_rename': permissions.includes('edit_properties') /* && unlocked */,
    // 'perm_follow': permissions.includes('item_preview') && !item.is_follow,
    // 'perm_unfollow': item.is_follow,
    'perm_view_tags': permissions.includes('item_view') && !permissions.includes('edit_properties'),
    'perm_edit_tags': permissions.includes('edit_properties'), // TODO if need to check unlocked
    'perm_permanent_delete': permissions.includes('permanent_delete') && is_owner,
    'perm_record_delete': permissions.includes('item_view') && !is_owner,
    'perm_restore': permissions.includes('item_restore'),
    'perm_view_properties': permissions.includes('item_view'),
    'perm_edit_properties': permissions.includes('edit_properties'), // TODO if need to check unlocked
    'perm_setting': permissions.includes('edit_properties') && item.type === 'folder',
    'perm_trash_properties': permissions.includes('item_view'),
    'perm_create': permissions.includes('item_upload'),
    'perm_create_file': /* permissions.includes('item_download') && */permissions.includes('item_upload'),
    'perm_upload': permissions.includes('item_upload'),
    'perm_action_when_locked': permissions.includes('item_view') && unlocked, // in case of empty permission
    // 'perm_collection': permissions.includes('item_upload') && item.type === 'folder' && COLLECTION_VERSION
    'perm-more-share-edit': permissions.includes('item_edit_collab')
  }

  for (let key in permission_list) {
    if (permission_list[key]) {
      action_permissions.push(key)
    }
  }

  return action_permissions
  /* eslint-enable eqeqeq */
}

// 文件操作
const permissionMap = {
  'menu_action': {
    'edit-online': ['perm_edit_online', { exclude: ['trash', 'share'] }],
    'frequent': ['perm_frequent', { exclude: ['trash', 'share'] }],
    'unfrequent': ['perm_unfrequent', { exclude: ['trash', 'share'] }],

    'view-version': ['perm_view_version', {include: ['preview']}],
    'share': ['perm_share', { exclude: ['trash', 'share'] }],
    // 'link-share': ['perm_share', { exclude: ['trash'] }],
    // 'colleague-share': ['perm_share_to_colleague', { exclude: ['trash'] }],

    'comment': ['perm_comment', { exclude: ['trash', 'share'] }],

    'move': ['perm_move', {exclude: ['share']}],
    'copy': ['perm_copy', {exclude: ['share']}],
    'download': ['perm_download', { exclude: ['trash', 'preview'] }],
    'delete': ['perm_delete', { exclude: ['share'] }],
    'rename': ['perm_rename', { exclude: ['share'] }],

    'restore': ['perm_restore', { include: ['trash'] }],
    'recode-delete': ['perm_record_delete', { include: ['trash'] }],
    'permanent-delete': ['perm_permanent_delete', { include: ['trash'] }],

    'attribute': ['perm_view_properties', { exclude: ['trash', 'share'] }],

    'save': ['perm_download', { include: ['share'] }]
  }
}

export const infoMap = {
  'edit-online': i18n.t('file.action.editOnline'),
  'frequent': i18n.t('file.create.frequent'),
  'unfrequent': i18n.t('file.action.unfrequent'),

  'view-version': i18n.t('file.revisions'),
  'share': i18n.t('file.action.share'),

  'comment': i18n.t('file.action.comment'),

  'download': i18n.t('base.download'),

  'move': i18n.t('file.action.move'),
  'copy': i18n.t('file.action.copy'),

  'delete': i18n.t('base.delete'),
  'rename': i18n.t('file.action.rename'),

  'permanent-delete': i18n.t('file.action.permanentDelete'),
  'recode-delete': i18n.t('file.action.deleteRecord'),
  'restore': i18n.t('file.action.restore'),

  'attribute': i18n.t('file.properties'),

  'save': i18n.t('base.save')
}

const checkPermissions = (permissions, action_type, scenario, menuExclude = []) => {
  const actions = permissionMap[action_type]
  let menu = []
  for (let act in actions) {
    let show = true
    for (let i = 0, l = actions[act].length; i < l; i++) {
      const perm = actions[act][i]
      if (typeof perm === 'object') {
        const perm_include = perm.include
        const perm_exclude = perm.exclude
        let include_show = true
        let exclude_show = true
        if (perm_include) include_show = perm_include.includes(scenario)
        if (perm_exclude) exclude_show = !perm_exclude.includes(scenario)
        show = include_show && exclude_show
      } else {
        show = permissions.includes(perm)
      }
      if (!show) break
    }

    if (show && !menuExclude.includes(act)) {
      menu.push(act)
    }
  }
  return menu
}

export const getActions = (data) => {
  const { actionPermissions,
    scenario,
    item,
    batchPermission,
    menuExclude
  } = data

  if (scenario === 'frequent' && item.freq_type === 'space') {
    return [item.item.is_frequently_used ? 'unfrequent' : 'frequent']
  }

  if (scenario === 'search' && item.type === 'space') {
    return [item.is_frequently_used ? 'unfrequent' : 'frequent']
  }

  if (actionPermissions) {
    let permissionsList = checkPermissions(actionPermissions, 'menu_action', scenario, menuExclude)
    if ((item.is_share_wps_edit) && scenario === 'share') {
      permissionsList = permissionsList.concat(['edit-online'])
    }
    return permissionsList
  } else if (batchPermission) {
    const { batchPermission: { permissions, type }, actionType } = data
    return checkPermissions([...permissions, type], actionType, scenario)
  }

  return []
}

// get pure file name for rename input value
export const pureName = (name, extension) => {
  let pure_name = name
  if (extension) {
    pure_name = pure_name.slice(0, -1 - extension.length)
  }
  return pure_name
}

export const normalizeUploadFile = (file, id) => {
  file.type = 'file'
  file.ext = getExt(file.name)

  Object.assign(file, {
    is_upload: true,
    id,
    typed_id: `${file.type}_${file.file_id ? file.file_id : id}`,
    type_icon: getTypeIcon(file),
    action_status: {}
  })

  return file
}

export const normalizeUploadFile4back = (item) => {
  let isUploadItem = !!item.is_upload
  let isFail = isUploadItem && item.error_msg
  let isUndone = isUploadItem && !item.error_msg
  let error_msg = null
  if (isFail) error_msg = item.error_msg
  if (isUndone) error_msg = 'undone'
  let file = {}
  file.id = isUploadItem ? undefined : item.id
  file.name = item.name
  file.size = item.size
  file.modified_at = isUploadItem ? undefined : item.modified_at
  file.type_icon = item.type_icon
  file.upload_status = !isUploadItem ? 'success' : 'fail'
  file.error_msg = error_msg || undefined
  return file
}

export const plusActionList = ['create-folder', 'upload-file']

const h5Upload = !!(window.File && window.FileReader && window.FileList && window.Blob)

let uploadIndex = 0
function getUid () {
  return `upload_${++uploadIndex}`
}

function getExt (name) {
  const lastIndex = name.lastIndexOf('.')
  return lastIndex < 1 ? '' : name.substr(lastIndex + 1).toLowerCase()
}

export const getUploadFiles = (files, uploadTarget) => {
  return new Promise((resolve, reject) => {
    let fileEntities = {}
    let fileNames = []
    let fileItem
    const postFiles = Array.prototype.slice.call(files)

    postFiles.forEach(file => {
      fileItem = {}
      const fileUid = getUid()
      fileItem.fileData = file
      fileItem.name = file.name
      fileItem.ext = getExt(file.name)
      fileItem.uploadTarget = uploadTarget
      fileItem.type_icon = getTypeIcon(fileItem)
      fileEntities[fileUid] = fileItem
      fileNames.push(file.name)
    })
    // if (uploadTarget) {
    //   detectFileNames(fileNames, uploadTarget, fileEntities, resolve, reject)
    // } else {
    resolve(fileEntities)
    // }
  })
}

// export const detectFileNames = (names, uploadTarget, fileEntities, resolve, reject) => {
//   // folder_xxx, own_0
//   const folderId = uploadTarget.split('_')[1]
//   if (folderId && names.length && uploadTarget.indexOf('collection') === -1) {
//     ajax({
//       url: DETECT_FILE_NAME,
//       data: {
//         folder_id: folderId,
//         file_names: names
//       }
//     }).then(json => {
//       if (json && json.success) {
//         const { files } = json
//         if (files.length) {
//           const uploadKeys = Object.keys(fileEntities)
//           const gernerator = (function* nameCheck (files) {
//             const len = files.length
//             for (let i = 0; i < len; i++) {
//               yield confirm({
//                 content: 'file.upload.existName',
//                 confirmText: 'file.upload.newVersion',
//                 buttonProps: [
//                   {
//                     text: 'file.upload.keepFile',
//                     onButtonClick (checked) {
//                       // skip set file_id, set keep_both
//                       const checkLen = checked ? len : (i + 1)
//                       for (let j = i; j < checkLen; j++) {
//                         uploadKeys.forEach(uploadKey => {
//                           if (fileEntities[uploadKey].name.toLowerCase() === files[j].name.toLowerCase()) {
//                             fileEntities[uploadKey].keep_both = true
//                           }
//                         })
//                       }

//                       if (checked || (i + 1 >= len)) {
//                         resolve(fileEntities)
//                       } else {
//                         gernerator.next()
//                       }
//                     }
//                   }
//                 ],
//                 checkboxText: len - i > 1 ? 'file.upload.checkText' : '',
//                 onConfirm (checked) {
//                   const checkLen = checked ? len : (i + 1)
//                   for (let j = i; j < checkLen; j++) {
//                     uploadKeys.forEach(uploadKey => {
//                       if (fileEntities[uploadKey].name.toLowerCase() === files[j].name.toLowerCase()) {
//                         fileEntities[uploadKey].file_id = files[j].id
//                       }
//                     })
//                   }
//                   if (checked || (i + 1 >= len)) {
//                     resolve(fileEntities)
//                   } else {
//                     gernerator.next()
//                   }
//                 },
//                 onCancel () {
//                   reject(false)
//                 },
//                 confirmButtonProps: {
//                   type: 'primary'
//                 },
//                 cancelButtonProps: {
//                   type: 'default'
//                 },
//                 className: 'upload-confirm'
//               })
//             }
//           })(files)
//           gernerator.next()
//           return
//         }
//       }
//       resolve(fileEntities)
//     })
//   } else {
//     resolve(fileEntities)
//   }
// }

export const triggerUploadFile = (callback, uploadTarget) => {
  if (!h5Upload) return
  let el = document.getElementById('upload-input')
  if (!el) {
    el = document.createElement('input')
    el.type = 'file'
    el.style.display = 'none'
    el.id = 'upload-input'
    el.multiple = 'multiple'

    document.body.appendChild(el)
  }

  el.onchange = (e) => {
    const files = e.target.files
    if (files.length > 0) {
      getUploadFiles(files, uploadTarget).then(data => {
        callback(data)
      })
    }
    // reset input for next file select
    el.value = ''
  }

  const evt = document.createEvent('MouseEvents')
  evt.initEvent('click', false, false)

  el.dispatchEvent(evt)
}

const spaceNames = {
  own: i18n.t('file.personalFiles'),
  collab: i18n.t('file.collabWithMe'),
  frequent: i18n.t('file.frequent'),
  trash: i18n.t('file.trash')
}

const spaceMap = {
  'personal_space': 'own',
  'collab_space': 'collab',
  'department_space': 'dept'
}

export const getSpaceName = space => {
  return spaceNames[spaceMap[space]]
}

export const getParentItem = item => {
  let parent = {}

  if (item.isDepartment) {
    if (item.departments_path.length) {
      Object.assign(parent, item.parent_department, {space: 'dept'})
    } else {
      // 0 级部门
      return null
    }
  } else if (['personal_space', 'collab_space', 'department_space'].includes(item.space)) {
    if (item.path && item.path.length) {
      Object.assign(parent, item.path[item.path.length - 1], {space: 'folder'})
    } else {
      parent = {
        space: spaceMap[item.space],
        id: item.space === 'department_space' ? item.department.id : null,
        name: item.space === 'department_space' ? item.department.name : getSpaceName(item.space)
      }
    }
  } else if (item.space === 'external_space') {
    if (item.path.length > 1) {
      Object.assign(parent, item.path[item.path.length - 1], {space: 'folder'})
    } else if (item.path.length === 1) {
      parent = {
        space: 'external',
        id: `${item.path[0].type}_${item.path[0].id}`,
        name: item.path[0].name
      }
    }
  }

  return parent
}

export const fullPathList4CollableFolder = item => {
  // 不属于部门空间根目录的文件夹 (部门空间根目录下)
  let type = item.full_space && item.full_space.type
  let isDepartmentNotRootFolder = type === 'department_space' && item.path_for_collab && (item.path_for_collab.length > 0)

  // 与我协作下的部门文件夹 (与我协作空间根目录下)
  let isCollableDepartmentFolder = item.isTopCollabFolder && item.department && (typeof item.department === 'object')

  // 与我协作下的个人文件夹
  let isOwnByOtherCollableFolder = item.isTopCollabFolder && item.owned_by && (!item.department || !(typeof item.department === 'object'))

  if (!isOwnByOtherCollableFolder && !isCollableDepartmentFolder && !isDepartmentNotRootFolder) return null

  // 1. 来自与我协作的个人文件夹
  // 2. 来自与我协作的部门文件夹（根空间下）
  // 3. 不属于部门空间根目录的文件夹
  let rootItem = null
  // 1. 来自与我协作的个人文件夹
  if (isOwnByOtherCollableFolder) {
    rootItem = {
      id: 0,
      name: item.owned_by.name,
      type: 'folder'
    }
  }
  // 2. 来自与我协作的部门文件夹
  if (isCollableDepartmentFolder) {
    let director = item.department.director
    let firstName = null
    if (director && (typeof director === 'object') && director.name) {
      firstName = `${item.department.name}(${i18n.t('collab.folder.manager')} ${director.name})`
    } else {
      firstName = `${item.department.name}(${i18n.t('collab.folder.nomanager')})`
    }
    rootItem = {
      id: 0,
      name: firstName,
      type: 'folder'
    }
  }
  // 3.来自部门空间下的非根目录文件夹
  if (isDepartmentNotRootFolder) {
    rootItem = {
      id: 0,
      name: item.department.name,
      type: 'folder'
    }
  }

  let fullPaths = []
  if (rootItem) fullPaths.push(rootItem)
  fullPaths = fullPaths.concat(item.path_for_collab)
  return fullPaths
}

export const isItemNeedsApproval = (item) => {
  if (item._needsApproval) { return true }
  if (Array.isArray(item)) {
    return item.some(i => isItemNeedsApproval(i))
  } else {
    return item.encrypted_item_in_path && !(
      (item.encrypted_item_in_path.review_user_id === config.user_info.id) ||
            ['owner', 'coowner'].includes(item.final_role)
    )
  }
}

export const checkScannedFile = (item) => {
  return item.scanned === 1 && config.viewConfig.isVirusScanEnabled
}

// 敏感文件判断
export const checkIsExternal = (item) => {
  const { id = '' } = config.enterprise_info
  return item.owned_by && String(item.owned_by.enterprise_id) !== String(id)
}

export const wpsShareEditOnline = (item) => {
  let permissions = item.permissions ? item.permissions : []

  return permissions.includes('item_upload') && permissions.includes('item_download') && ((item.type === 'file' && item.is_online_collab_edit_enable) || item.type === 'folder') && !config.viewConfig.is_changxie_edit_enabled
}
